"use strict";const n=(e,t)=>e.call(t);export default n;
//# sourceMappingURL=executeTemplate.js.map
